import { ThemeProvider } from "./components/ThemeContext";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import QAWork from "./components/QAWork";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <ThemeProvider>
      <div className="min-h-screen" style={{ fontFamily: "var(--font-sans)", background: "var(--background)" }}>
        <Nav />
        <main>
          <Hero />
          <About />
          <Skills />
          <Projects />
          <QAWork />
          <Contact />
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
